module.exports = __webpack_public_path__ + "static/img/74-1.0696bc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/74-1.jpg
// module id = Zfmg
// module chunks = 0